import { request } from '../request';

export const loadCalendarEvent = async (shortId: string) => {
  const response = await request(`v1/calendar-events/${shortId}/`);
  return response.data;
};
